import { useState, useEffect, useRef } from "react";

export default function ChatBot() {
    const [messages, setMessages] = useState([]);
    const [input, setInput] = useState("");
    const [loading, setLoading] = useState(false);
    const messagesEndRef = useRef(null);

    const scrollToBottom = () => {
        messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
    };

    useEffect(() => {
        scrollToBottom();
    }, [messages, loading]);

    const sendMessage = async () => {
        if (!input.trim()) return;
        const newHistory = [...messages, { role: "user", content: input }];
        setMessages(newHistory);
        setLoading(true);

        try {
            const response = await fetch("https://ai-test-work.180519.xyz", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ message: input })
            });

            const data = await response.json();
            const reply = data?.[0]?.response?.response || "AI 没有返回答案。";

            setMessages([...newHistory, { role: "assistant", content: reply }]);
            setInput("");
        } catch (error) {
            setMessages([...newHistory, { role: "assistant", content: "出错了，请稍后重试。" }]);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="h-screen bg-gray-100 flex items-center justify-center">
            <div className="flex flex-col h-full w-[45%] bg-white shadow-lg rounded-xl overflow-hidden">

                <div className="p-4 border-b text-center text-lg font-semibold bg-blue-600 text-white">
                    问答助手1.0
                </div>

                <div className="flex-1 p-4 overflow-auto space-y-3 bg-gray-50">
                    {messages.map((m, i) => (
                        <div key={i} className={`flex ${m.role === "user" ? "justify-end" : "justify-start"}`}>
                            <div className={`p-3 max-w-[70%] rounded-2xl whitespace-pre-wrap break-words ${
                                m.role === "user"
                                    ? "bg-blue-500 text-white rounded-br-none"
                                    : "bg-gray-300 text-black rounded-bl-none"
                            }`}>
                                {m.content}
                            </div>
                        </div>
                    ))}

                    {loading && (
                        <div className="flex justify-start">
                            <div className="p-3 bg-gray-300 text-black rounded-2xl max-w-[70%] rounded-bl-none">
                                AI 正在思考...
                            </div>
                        </div>
                    )}

                    <div ref={messagesEndRef} />
                </div>

                <div className="p-3 border-t bg-white flex gap-2">
                    <input
                        className="flex-1 border p-2 rounded"
                        value={input}
                        onChange={e => setInput(e.target.value)}
                        onKeyDown={e => e.key === "Enter" && sendMessage()}
                        placeholder="输入你的问题..."
                    />
                    <button
                        className="bg-blue-600 text-white px-4 py-2 rounded"
                        onClick={sendMessage}
                        disabled={loading}
                    >
                        {loading ? "发送中..." : "发送"}
                    </button>
                </div>
            </div>
        </div>
    );
}
